import React from "react"
import { Section, Container, MarkdownContent} from "../../components/Section"

const WelcomeSection = () => {
	return(
        <Section ept="60px" epb="40px" xpt="40px" xpb="20px" pt="30px" pb="10px" bgColor="#373636" className="section-welcome">
            <Container className="container" maxWidth="1280px">
                <MarkdownContent color="#fff" textAlign="center">
                    <h2>Trust EMB Metal Buildings for Projects Small and Large</h2>                    
                    <p>Whether you're building a backyard garage or a full-scale workshop, EMB Metal Buildings is here to help you every step of the way. We take pride in delivering strong, stylish, affordable metal buildings that stand the test of time. We offer industry-leading warranties, such as craftsmanship guarantees and flexible financing options for your budget.</p>
                    <p>Call our building experts today at <a href="tel:2085721441" aria-label="phone number">(208) 572-1441</a> or use our 3D building estimator online to customize a structure to suit your next big project. We’ll guide you every step of the way and create a structure that puts in the work for you daily.</p>
                </MarkdownContent>
            </Container>
        </Section>
	)
}
export default WelcomeSection
